import React, { FC } from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { InjectedIntlProps } from '../../../../../doctrine.types';

type Props = InjectedIntlProps & {
  value: string;
  hasError: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

const monthsLabels = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];

export const RawDecisionUploadMonthField: FC<Props> = ({
  value,
  hasError,
  onChange,
  intl,
}) => {
  return (
    <select
      value={value}
      className={classNames(hasError && 'is-invalid-input')}
      name="month"
      onChange={onChange}
    >
      <option disabled value="">
        {intl.formatMessage({
          id: 'form/DecisionUploadMonthField.tsx/1',
        })}
      </option>
      {monthsLabels.map(month => (
        <option key={month} value={month}>
          {month}
        </option>
      ))}
    </select>
  );
};

export const DecisionUploadMonthField = injectIntl(RawDecisionUploadMonthField);
